module.exports = __webpack_public_path__ + "img/builder-icon-white.aef42c11.svg";